import { render } from "./create-prospect.vue?vue&type=template&id=4297c842&scoped=true"
import script from "./create-prospect.vue?vue&type=script&lang=js"
export * from "./create-prospect.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./create-prospect.vue?vue&type=style&index=1&id=4297c842&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4297c842"]])

export default __exports__